import { useLocation } from 'react-router-dom'

const pathMap = [
  { path: '/login', label: 'Login' },
  { path: '/users', label: 'Utenti' }
]

export const usePageTitle = () => {
  useLocation()
  if (window.location.pathname === '/') return 'Home'

  const matchTitle = ({ path }) => path === window.location.pathname

  return pathMap.find(matchTitle)?.label || 'Home'
}

export const useMenuItems = (username) => ([
  (username === 'admin' && { label: 'Crea Utenza', icon: 'add', path: '/users/list' }),
  { label: 'Report', icon: 'paperwork-2', path: '/report/list' },
  { label: 'Logout', icon: 'primeicon pi-power-off', path: 'logout' }
].filter(Boolean))
